import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BackOfficeHome } from 'src/app/Services/Api.BackOfficeHome/BackOfficeHome';
import { OpenModal } from 'src/app/OpenModal';
import { RespuestaItem } from '../../../../../src/app/Models/Shared/Respuesta';
import { ServicesCommon } from '../../../Services/Api.Common/ServicesCommon';
import { BilleteraService } from '../../../Services/Api.Billetera/BilleteraService'
import { VentasListComponent } from '../ventas-list/ventas-list.component';
import { TypeDialog, ButtonsDialog } from 'src/app/model-type';
import { resetFakeAsyncZone } from '@angular/core/testing';
import { ConceptoFacturacion } from 'src/app/Models/Facturacion/Facturacion';
import { BackOfficeSession } from 'src/app/Services/Api.BackOfficeSession/BackOfficeSession';
import { ComercioHome } from 'src/app/Models/Comercio/Comercio';

@Component({
  selector: 'app-ventas-add',
  templateUrl: './ventas-add.component.html',
  styleUrls: ['./ventas-add.component.css']
})
export class VentasAddComponent implements OnInit {

  perfiles: any[] = [];
  sucursales: any[] = [];
  Form: FormGroup;
  Submitted = false;
  Guardar = false;
  Loading = false;
  BusquedaPorPlaca = true;
  BusquedaExitosa = false;
  clienteID = 0;
  cuentaVehiculoID = 0;
  valor: string;
  valorIva: string;
  correo: string;
  conceptosFacturacion: ConceptoFacturacion[];
  comercio: ComercioHome;
  valorImpuesto =0;

  public TipoNatural: TipoDocumento[];
  public EsquemasPago: any[] = [];

  constructor(private _BilleteraService: BilleteraService, private fb: FormBuilder, private _authenticationService: BackOfficeSession,
    public dialogRef: MatDialogRef<VentasListComponent>, @Inject(MAT_DIALOG_DATA) public data:
      any, private _Common: ServicesCommon, private OModal: OpenModal) {
    this.Form = this.fb.group({
      opcion: ['1'],
      placa: [''],
      tipoDocumento: [''],
      numeroDocumento: [''],
      esquemaPago: [''],
      montoTotal: [''],
      montoIVA: [''],
      nombreCompleto: [''],
      comercioCategoria: [''],
      estado: [''],
      codigoConfirmacion: [''],
      documentoTipoID: [''],
      documentoNumero: [''],
      conceptoID: [''],
    })
  }

  ngAfterViewInit() {
    
  }

  ngOnInit() {
    this.onObtenerTipoNatural();
    this.cargarConceptos();
    //this.infoComercio();
  }

  currencyInputChanged(value) {
    if (value != null || !isNaN(value)) {
    //  this.valor = value.replace(/[^\d-]/g, '');
      let precioTotal: number = +value;
      //this.valor = value;
      if (this.valorImpuesto > 0) {
     //   let calculo= (numberValue * (this.valorImpuesto / 100)+1).toFixed(0);
        let calculo = ((precioTotal / (100 + this.valorImpuesto)) * 100).toFixed(0);
        let valorFinal = (precioTotal - Number(calculo)).toFixed(0);
        this.Form.controls['montoIVA'].setValue(valorFinal);
      } else
        this.Form.controls['montoIVA'].setValue(0);
    }
  }


  currencyInputChangedIVA(value) {
    //this.valorIva = value.replace(/[^\d-]/g, '');
    this.valorIva = value;

  }


  deshabilitarControlesBusqueda() {
    this.Form.get('opcion').disable();
    this.Form.get('placa').disable();
    this.Form.get('montoIVA').disable();
    this.Form.get('nombreCompleto').disable();
    this.Form.get('comercioCategoria').disable();
    this.Form.get('esquemaPago').disable();
  }

  buscarXDocumento() {
    this.Loading = true;
    this._BilleteraService.buscarClientexPlaca(this.Form.get('placa').value).subscribe(res => {
      const artcl: any = res.recordset;
      if (artcl != null) {
        this.BusquedaExitosa = !this.BusquedaExitosa;
        this.deshabilitarControlesBusqueda();
        this.Form.get('nombreCompleto').setValue(artcl[0].nombreCompleto);
        this.clienteID = artcl[0].clienteID;
        this.EsquemasPago = artcl.map((value: any) => {
          return {
            esquemaPagoID: value.esquemaPagoID,
            esquemaPago: value.esquemaPago,
          }
        });
      }
    },
      err => {
        console.error(err);
      }, () => this.Loading = false
    );
  }

  buscarXPlaca() {
    this.Loading = true;
    if (this.Form.get('placa').value.length >= 6)
      this._BilleteraService.buscarClientexPlaca(this.Form.get('placa').value).subscribe(res => {
        if (res.recordset != null) {
          const artcl: any = res.recordset[0];
          this.correo = artcl.correo;
          this.BusquedaExitosa = !this.BusquedaExitosa;
          this.deshabilitarControlesBusqueda();
          this.Form.get('nombreCompleto').setValue(artcl.nombreCompleto);
          this.Form.get('esquemaPago').setValue(artcl.esquemaPagoID);
          this.Form.get('documentoTipoID').setValue(artcl.documentoTipoID);
          this.Form.get('documentoNumero').setValue(artcl.documentoNumero);

          this.clienteID = artcl.clienteID;
          this.cuentaVehiculoID = artcl.cuentaVehiculoID;
          this.EsquemasPago = [{
            esquemaPagoID: artcl.esquemaPagoID,
            esquemaPago: artcl.esquemaPago,
          }]
        } else {
          this.OModal.openDialog(
            TypeDialog.information,
            "Advertencia",
            "No se encontrarón registros en el sistema o la placa esta inactiva",
            ButtonsDialog.ok,
            300
          );
        }
      },
        err => {
          console.error(err);
        }, () => this.Loading = false
      );
  }

  onRadioChange($event) {
    this.BusquedaPorPlaca = !this.BusquedaPorPlaca;
  }
  onCancelar() {
    this.dialogRef.close();
  }

  onCrear() {
    this.Submitted = true;
    if (this.Form.valid === false) {
      return false;
    }



    this.data = {
      clienteID: this.clienteID,
      comercioID: sessionStorage.getItem('comercioID'),
  //  montoTotal: Number(this.valor.replace(/[^\d-]/g, '')),
      montoTotal: this.Form.get('montoTotal').value,
      montoIVA: this.Form.get('montoIVA').value,
      esquemaPagoID: this.Form.get('esquemaPago').value,
      cuentaVehiculoID: this.cuentaVehiculoID,
      conceptoID : this.Form.get('conceptoID').value,
      referenciaComercio: '',
    };

    if (this.data.montoTotal < 100) {
      this.OModal.openDialog(
        TypeDialog.information,
        "Advertencia",
        "El valor total de la compra debe ser un valor mayor o igual $100",
        ButtonsDialog.ok,
        300
      );
      this.Form.get('montoTotal').setValue(0);
      return false;
    }

    if (this.data.montoIVA >= this.data.montoTotal) {
      this.OModal.openDialog(
        TypeDialog.information,
        "Advertencia",
        "El monto del IVA no puede ser superior al monto total",
        ButtonsDialog.ok,
        300
      );
      return false;
    }

    var Totp = {
      codigoOtp: this.Form.get('codigoConfirmacion').value,
      placa: this.Form.get('placa').value,
      servicioId: "",
      tipoServicio: "",
      documentoNumero: this.Form.get('documentoNumero').value,
      documentoTipoID: this.Form.get('documentoTipoID').value
      //  personaTipo: "Natural"
    }

    this.Loading = true;

    this._BilleteraService.verificarOtp(Totp).subscribe(res => {
      const artcl: RespuestaItem = res;
      if (artcl.record != null) {
        this.onAgregarVenta(artcl.record.ticketOtp);
      } else if (artcl.error != null) {
        this.Loading = false
        this.Form.get('codigoConfirmacion').setValue("");
        this.OModal.openDialog(
          TypeDialog.information,
          "Advertencia",
          artcl.error.description,
          ButtonsDialog.ok,
          300
        );
      }
    },
      err => {
        console.error(err);
        this.Loading = false
      }
    );
  }

  onAgregarVenta(value) {
    this.data.ticketOtp = value;
    this._BilleteraService.agregarVenta(this.data).subscribe(res => {
      const artcl: RespuestaItem = res;
      if (artcl.error != null) {
        this.Form.get('codigoConfirmacion').setValue("");
        this.OModal.openDialog(
          TypeDialog.information,
          "Advertencia",
          artcl.error.description,
          ButtonsDialog.ok,
          300
        );
        this.Loading = false
      }
      else if (artcl.record != null) {
        this.dialogRef.close(true);
        // this.Loading = false
      }

    },
      err => {
        this.Loading = false
        console.error(err);
      }
    );

  }
  onObtenerTipoNatural() {
    this._Common.tipoDocumentosNatural().subscribe(res => {
      const record = (res as any).recordset;
      if (record != null)
        this.TipoNatural = record;
    },
      err => {
        console.warn(err);
      });
  }

  cargarConceptos() {
    this._Common.FacturacionConceptosBilletera().subscribe((res) => {
      const record = (res as any).recordset;
      if (record != null) {
        this.conceptosFacturacion = record;
        this.infoComercio();
        
      }
    })
  }

  infoComercio() {
    this._authenticationService.obtenerInfoComercio(sessionStorage.getItem('comercioID')).subscribe((res :any) =>{
      if (res.record){
        this.comercio = res.record;
        this.Form.get('comercioCategoria').setValue(this.comercio.categoria);
       // this.Form.get('conceptoID').setValue(this.comercio.conceptoID);
        this.Form.controls['conceptoID'].setValue(this.comercio.conceptoID);
        this.valorImpuesto =  this.conceptosFacturacion.find(a=> {return a.conceptoID == this.Form.get('conceptoID').value}).porcentajeIVA;
  
      }
    })
  }

  onImpuestoSelected(event:any){
    var IdConcepto = event.value;
    this.valorImpuesto =  this.conceptosFacturacion.find(a=> {return a.conceptoID == IdConcepto}).porcentajeIVA;
    this.currencyInputChanged(this.Form.get('montoTotal').value);
  }

}

